import React from 'react';
import { Wifi, CheckCircle2 } from 'lucide-react';

const ResponsibleUse = () => {
  return (
    <section className="responsible-use-section px-4 py-14 md:py-20 bg-[#0d0d0d]">
      <div className="container mx-auto max-w-4xl">
        <div className="responsible-use-panel bg-gradient-to-r from-[#111] to-[#0d0d0d] border border-white/10 rounded-3xl px-2 py-4 md:px-0 md:py-5">
          <div className="grid gap-9 text-left md:grid-cols-2 md:gap-0">
            <div>
              <h3 className="font-bold text-white text-2xl mb-4 flex items-center gap-3">
                <Wifi className="w-6 h-6 text-[#68b8ff]" />
                The everyday problem
              </h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Public Wi-Fi, travel networks and expensive roaming can make staying connected less secure, less reliable and unnecessarily complicated.
              </p>
            </div>
            <div>
              <h3 className="font-bold text-white text-2xl mb-4 flex items-center gap-3">
                <CheckCircle2 className="w-6 h-6 text-[#3affc2]" />
                The PhantomPath approach
              </h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Choose flexible VPN access, travel data or a separate number when you need it — with no ongoing subscription.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResponsibleUse;
